import { useState } from 'react';

interface ShareModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  text: string;
  url?: string;
}

export function ShareModal({ isOpen, onClose, title, text, url = 'https://SYMSVOX.com' }: ShareModalProps) {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const fullText = `${text} ${url}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(fullText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareToTwitter = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
      '_blank',
      'width=550,height=420'
    );
  };

  const shareToDiscord = () => {
    navigator.clipboard.writeText(fullText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareToReddit = () => {
    window.open(
      `https://reddit.com/submit?title=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`,
      '_blank'
    );
  };

  const shareToFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`,
      '_blank',
      'width=550,height=420'
    );
  };

  const shareToInstagram = () => {
    // Instagram doesn't have a direct share URL — copy to clipboard for paste into story/post
    navigator.clipboard.writeText(fullText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareToTelegram = () => {
    window.open(
      `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
      '_blank'
    );
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-50"
        style={{ background: 'rgba(0,0,0,0.5)' }}
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="fixed z-50 social-box shadow-lg"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '340px',
        }}
      >
        <div className="box-header flex items-center justify-between">
          <span>Share</span>
          <button
            onClick={onClose}
            className="cursor-pointer"
            style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '14px' }}
          >
            ✕
          </button>
        </div>

        <div className="p-3 space-y-3">
          {/* Preview */}
          <div className="p-2" style={{ background: 'var(--bg-deep)', border: '1px solid var(--border-separator)', fontSize: '11px' }}>
            <div className="font-bold" style={{ color: 'var(--text-primary)' }}>{title}</div>
            <div className="mt-0.5" style={{ color: 'var(--text-muted)' }}>{text}</div>
          </div>

          {/* Share Buttons */}
          <div className="grid grid-cols-3 gap-2">
            <button
              onClick={shareToTwitter}
              className="flex items-center justify-center gap-1.5 py-2 font-bold text-xs cursor-pointer"
              style={{ background: '#1da1f2', color: 'white', border: '1px solid #1a8cd8' }}
            >
              𝕏 Post on X
            </button>
            <button
              onClick={shareToFacebook}
              className="flex items-center justify-center gap-1.5 py-2 font-bold text-xs cursor-pointer"
              style={{ background: '#1877f2', color: 'white', border: '1px solid #1565c0' }}
            >
              Facebook
            </button>
            <button
              onClick={shareToInstagram}
              className="flex items-center justify-center gap-1.5 py-2 font-bold text-xs cursor-pointer"
              style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)', color: 'white', border: '1px solid #cc2366' }}
            >
              Instagram
            </button>
            <button
              onClick={shareToDiscord}
              className="flex items-center justify-center gap-1.5 py-2 font-bold text-xs cursor-pointer"
              style={{ background: '#5865f2', color: 'white', border: '1px solid #4752c4' }}
            >
              Discord
            </button>
            <button
              onClick={shareToReddit}
              className="flex items-center justify-center gap-1.5 py-2 font-bold text-xs cursor-pointer"
              style={{ background: '#ff4500', color: 'white', border: '1px solid #cc3700' }}
            >
              Reddit
            </button>
            <button
              onClick={shareToTelegram}
              className="flex items-center justify-center gap-1.5 py-2 font-bold text-xs cursor-pointer"
              style={{ background: '#0088cc', color: 'white', border: '1px solid #006699' }}
            >
              Telegram
            </button>
          </div>

          {/* Copy Link */}
          <div className="flex gap-2">
            <input
              type="text"
              readOnly
              value={url}
              className="flex-1 px-2 py-1.5 text-2xs"
              style={{ background: 'var(--bg-filter)', border: '1px solid var(--border-separator)', color: 'var(--text-secondary)' }}
            />
            <button
              onClick={handleCopy}
              className="px-3 py-1.5 text-xs font-bold cursor-pointer shrink-0"
              style={{
                background: copied ? '#10b981' : 'var(--accent)',
                color: 'white',
                border: `1px solid ${copied ? '#059669' : 'var(--accent-hover)'}`,
              }}
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
